import container from "./index";
import * as hubs from "../services/hubs";

container.bind<hubs.IHubManager>(hubs.iid_HubManager).toConstantValue(new hubs.HubManager());

//container.bind(hubs.iid_TestHub).toConstantValue(new hubs.TestHub());
container.bind(hubs.iid_FormsHub).toConstantValue(new hubs.FormsHub());
